/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var user = "Guest";
  var nickname = "Guest";
  var available = "0.00";
  var outstanding = "0.00";
  var balance = "0.00";
  var version = window.version;

  var tabgd = function tabgd() {
    $(".rowgd").show();
    $(".rowsg").hide();
    $(".rowst").hide();
    $(".rowext1").show();
    $(".rowext2").hide();
    $(".tabgd").addClass("button-active");
    $(".tabsg").removeClass("button-active");
    $(".tabst").removeClass("button-active");
    $update();
  };

  var tabsg = function tabsg() {
    $(".rowgd").hide();
    $(".rowsg").show();
    $(".rowst").hide();
    $(".rowext1").hide();
    $(".rowext2").show();
    $(".tabgd").removeClass("button-active");
    $(".tabsg").addClass("button-active");
    $(".tabst").removeClass("button-active");
    $update();
  };

  var tabst = function tabst() {
    $(".rowgd").hide();
    $(".rowsg").hide();
    $(".rowst").show();
    $(".rowext1").hide();
    $(".rowext2").show();
    $(".tabgd").removeClass("button-active");
    $(".tabsg").removeClass("button-active");
    $(".tabst").addClass("button-active");
    $update();
  };

  var logout = function logout() {
    console.log("logout");
    localStorage.setItem("username", "");
    localStorage.setItem("password", "");
    localStorage.setItem("nickname", "");
    $f7.views.main.router.navigate("/agent_home/", {
      reloadCurrent: true,
      force: true
    });
  };

  var alertNotReady = function alertNotReady() {
    localStorage.clear();
    $f7.dialog.alert("Page design not yet available");
  }; // $on('pageAfterIn', () => {  
  //   $f7.toolbar.hide(".toolbar-app");
  // })


  var checkwallet = function checkwallet(val) {
    window.wallet = "false";
    $f7.views.main.router.navigate(val);
  };

  var checkngo = function checkngo(val, special) {
    if (special != "yes") {
      if (window.SGDraw == "ON") {
        $f7.views.main.router.navigate(val);
      } else {
        $f7.dialog.alert("Not available at this time");
      }
    } else {
      if (window.SSDraw == "ON") {
        $f7.views.main.router.navigate(val);
      } else {
        $f7.dialog.alert("Not available at this time");
      }
    }

    return;
    $f7.preloader.show();
    $f7.request({
      method: 'get',
      url: window.waypoint + 'balance.aspx',
      data: {
        latitude: window.lat,
        longitude: window.lot,
        reqid: window.uuid,
        action: "none"
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        $f7.preloader.hide();
        console.log("Output:" + data);
        data = JSON.parse(data);

        if (special != "yes") {
          if (data.SGDraw == "ON") {
            $f7.views.main.router.navigate(val);
          } else {
            $f7.dialog.alert("Not available at this time");
          }
        } else {
          if (data.SSDraw == "ON") {
            $f7.views.main.router.navigate(val);
          } else {
            $f7.dialog.alert("Not available at this time");
          }
        }
      }
    });
  };

  var checkBalance = function checkBalance() {
    $f7.request({
      method: 'get',
      url: window.waypoint + 'balance.aspx',
      data: {
        latitude: window.lat,
        longitude: window.lot,
        reqid: window.uuid,
        action: "none"
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log("Output:" + data);
        data = JSON.parse(data);
        console.log(data.available);
        available = parseFloat(data.available).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        outstanding = parseFloat(data.outstanding).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        balance = parseFloat(data.balance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        $(".available").html("$ " + available);
        $(".outstanding").html("$ " + outstanding);
        $(".balance").html("$ " + balance);
        $(".whatsapp").attr("href", "https://t.me/" + data.tgnum);
        console.log($(".whatsapp").attr("href"));
        window.countdowngd = new Date(data.GDStopTime);
        window.countdownsg = new Date(data.SGStopTime);
        window.countdownst = new Date(data.SLStopTime);
        $(".gdclosetime").html(data.GDStopTime);
        $(".sgclosetime").html(data.SGStopTime);
        $(".stclosetime").html(data.SLStopTime);
        window.SGDraw = data.SGDraw;
        window.SSDraw = data.SSDraw;
        $(".wallet-amount").html("$" + data.wallet.toFixed(2));
        $(".badge-outstanding").html("$" + data.outstanding.toFixed(2));
        $(".badge-wallet").html("$" + data.wallet.toFixed(2));
        window.wallet_amount = data.wallet.toFixed(2);
        $update();
      }
    });
  };

  $on('pageInit', function () {
    window.waypoint = window.atob("aHR0cHM6Ly9hcGkuZ2Rsb3R0by50bC9qc29uLw==");
    window.waypointGEN = window.atob("aHR0cHM6Ly9hcGkuZ2Rsb3R0by50bC8=");
    window.checkbalance = true;
    tabgd();
    user = localStorage.getItem("username"); //$(".col-topup").hide();
    //$(".col-outstanding").hide();

    if (window.agentType == "MA" || window.agentType == "KA") {
      $(".col-topup").show();
      $(".col-outstanding").hide();
    }

    if (window.agentType == "PA") {
      $(".col-topup").hide();
      $(".col-outstanding").show();
    }

    if (window.agentType == "AG") {
      $(".col-topup").show();
      $(".col-outstanding").show();
    }

    if (localStorage.getItem("username") != "" && localStorage.getItem("username") != undefined) checkBalance();
    setInterval(function () {
      window.checkbalance = true;
    }, 1800000);
    setInterval(function () {
      if (localStorage.getItem("username") != "" && localStorage.getItem("username") != undefined && window.checkbalance == true) checkBalance();
      window.checkbalance = false;
    }, 3000);
    setInterval(function () {
      if (window.countdowngd != "" && window.countdowngd != undefined) {
        timeBetweenDates(window.countdowngd, "gd");
        timeBetweenDates(window.countdownsg, "sg");
        timeBetweenDates(window.countdownst, "st");
      } else {
        window.checkbalance = true;
      }
    }, 1000);
    $update();
  });

  function timeBetweenDates(toDate, type) {
    var dateEntered = toDate;
    var now = new Date();
    var difference = dateEntered.getTime() - now.getTime();

    if (difference <= 0) {
      checkBalance();
    } else {
      var seconds = Math.floor(difference / 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);
      var days = Math.floor(hours / 24);
      hours %= 24;
      minutes %= 60;
      seconds %= 60;
      hours = hours + days * 24;
      $("." + type + "hours").html(hours);
      $("." + type + "minutes").html(minutes);
      $("." + type + "seconds").html(seconds);
    }
  }

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">

    <!-- Top Navbar -->
    <div class="navbar navbar-transparent">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <!-- <div class="left">
          <a href="#" class="link icon-only panel-open" data-panel="left">
            <i class="icon f7-icons">chevron_left</i>
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div> -->                                                                                                                 
        <div class="title sliding">GD Lotaria</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons">text_bubble</i>
            <!-- <i class="icon f7-icons if-not-md">menu</i> -->
            <!-- <i class="icon material-icons if-md">menu</i> -->
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content">

      <div style="background-image: url('static/images/longlong.png'); background-repeat: no-repeat;background-size: cover;background-color: var(--f7-theme-color); height: 250px; margin-top: -150px; border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;">
 
      </div>


      
      <div class="block" style="color: white; margin-top: -130px;" >
        
        <table>
          <td width=80px>
            <img src="static/images/gd.png" width=70px style="vertical-align: middle;"/>
          </td>
          <td>
            <H2 style="position:relative; top:-5px">
              <span class='en'>GD Lotaria Agent</span>
              <span class='cn'>GD Lotaria 代理人</span>
              <span class='tl'>Ajente GD Lotaria</span>
            </H2>
            <span style="font-size:16px;position:relative; top:-25px">
              <span class='en'>Good Day</span>
              <span class='cn'>您好</span>
              <span class='tl'>Loron Diak</span>
            , <span id="nickname"></span></span>
          </td>
        </table>

        <div class="row" style="margin-top: -20px;">
          <div class="col-50">
            
          </div>
          <div class="col-50" style="text-align: right;">
            
              <span class='en'>Version </span>
              <span class='cn'>版本</span>
              <span class='tl'>Versaun</span>
            ${version}
          </div>
        </div> 
        <marquee>
          <span class='en'>Have a new number? Be the winner..</span>
          <span class='cn'>有新号码吗？成为赢家..</span>
          <span class='tl'>Iha Numeru Foun? Sai manan nain..</span>
        </marquee>
        
      </div>
      
      <div class="card" style="margin-top: -30px; border-radius: 10px;">
        <table width=100%>
          <thead>
            <tr>
              <th>
                <span class='en'>Available</span>
                <span class='cn'>信用限额</span>
                <span class='tl'>Disponivel</span>
              </th>
              <th>
                <span class='en'>Outstanding</span>
                <span class='cn'>未完成交易</span>
                <span class='tl'>Sei adia fali</span>
              </th>
              <th>
                <span class='en'>Balance</span>
                <span class='cn'>余额</span>
                <span class='tl'>Balansu</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="text-align: center;" class="available">$ 0.00</td>
              <td style="text-align: center;" class="outstanding">$ 0.00</td>
              <td style="text-align: center;" class="balance">$ 0.00</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class='.auth'>

      </div>

      <p class="segmented segmented-round block">
        <button class="button button-round button-outline button-active tabgd" @click=${tabgd} style="height: 40px;"><img src="static/images/gd.png" width="25px" /><span style="font-size: smaller;position:relative;left:5px">GD Lotto</span></button>
        <button class="button button-round button-outline tabsg" @click=${tabsg} style="height: 40px;"><img src="static/images/sg.png" width="25px" /><span style="font-size: smaller;position:relative;left:5px">SG Lottery</span></button>
        <button class="button button-round button-outline tabst" @click=${tabst} style="height: 40px;"><img src="static/images/slotto.png" width="40px" style="left: -5px;"/><span style="font-size: smaller;position:relative;left:5px">S-Lotto</span></button>
      </p>

      <div class="block rowgd" style="text-align: center;font-size: 25px; margin-bottom: 10px; margin-top:-20px;">
        <span class="gdhours">0</span>
        <span style="font-size: 18px;color:gray;"> 
          <span class='en'>hrs</span>
          <span class='cn'>时</span>
          <span class='tl'>hrs</span>
         </span> 
         <span class="gdminutes">0</span>
         <span style="font-size: 18px;color:gray;"> 
           <span class='en'>min</span>
           <span class='cn'>分</span>
           <span class='tl'>min</span>
         </span> 
         <span class="gdseconds">0</span>
         <span style="font-size: 18px;color:gray;"> 
            <span class='en'>sec</span>
            <span class='cn'>秒</span>
            <span class='tl'>sec</span>
          </span> 
        <br/><span class="gdclosetime" style="font-size: 18px;color:gray;">Close Time</span>
      </div>
      <div class="block rowsg" style="text-align: center;font-size: 25px; margin-bottom: 10px; margin-top:-20px;">
        <span class="sghours">0</span>
        <span style="font-size: 18px;color:gray;"> 
          <span class='en'>hrs</span>
          <span class='cn'>时</span>
          <span class='tl'>hrs</span>
         </span> 
         <span class="sgminutes">0</span>
         <span style="font-size: 18px;color:gray;"> 
           <span class='en'>min</span>
           <span class='cn'>分</span>
           <span class='tl'>min</span>
         </span> 
         <span class="sgseconds">0</span>
         <span style="font-size: 18px;color:gray;"> 
            <span class='en'>sec</span>
            <span class='cn'>秒</span>
            <span class='tl'>sec</span>
          </span> 
        <br/><span class="sgclosetime" style="font-size: 18px;color:gray;">Close Time</span>
      </div>
      <div class="block rowst" style="text-align: center;font-size: 25px; margin-bottom: 10px; margin-top:-20px;">
        <span class="sthours">0</span>
        <span style="font-size: 18px;color:gray;"> 
          <span class='en'>hrs</span>
          <span class='cn'>时</span>
          <span class='tl'>hrs</span>
         </span> <span class="stminutes">0</span>
         <span style="font-size: 18px;color:gray;"> 
           <span class='en'>min</span>
           <span class='cn'>分</span>
           <span class='tl'>min</span>
         </span> <span class="stseconds">0</span>
         <span style="font-size: 18px;color:gray;"> 
            <span class='en'>sec</span>
            <span class='cn'>秒</span>
            <span class='tl'>sec</span>
          </span> 
        <br/><span class="stclosetime" style="font-size: 18px;color:gray;">Close Time</span>
      </div>
      

      
      
      <div class="block rowgd" style="margin-top: 0px;">
        <div class="row">
          <div class="col" style="display: flex;justify-content: center;" >
            <a href="/kiosk_4d_GD/">
            <div style="background-color: var(--f7-theme-color); width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/gd.png" width=40%/>
                <br/>
                4D,3D,2D
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/kiosk_6d_GD/">
            <div style="background-color: orange; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: black; text-align: center;">
                <img src="static/images/gd.png" width=40%/>
                <br/>
                6D 
                  <span class='en'>Only</span>
                  <span class='cn'>仅有</span>
                  <span class='tl'><br/>Mesak deit</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/kiosk_pick_gd/">
            <div style="background-color: green; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/gd.png" width=40%/>
                <br/>
                SEPER PICK
              </span> 
            </div>
            </a>
          </div>
          
          
        </div>
        <br/>
        <div class="row">
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/kiosk_result_gd/" class="tab-link">
            <div style="background-color: gray; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: black; text-align: center;">
                <img src="static/images/gd.png" width=50px/>
                <br/>
                
                  <span class='en'>Result</span>
                  <span class='cn'>成绩</span>
                  <span class='tl'>Rejultadu</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/agent_winning/" class="tab-link">
            <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/trophy.png" width=50px/>
                <br/>
                
                  <span class='en'>Winning</span>
                  <span class='cn'>中奖</span>
                  <span class='tl'>Manan nain</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
          <!-- <div class="col" @click="${alertNotReady}" style="display: flex;justify-content: center;"> -->
            <a href="/agent_jackpot/">
            <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/jackpot1.png" width=50px/>
                <br/>
                Jackpot
              </span> 
            </div>
            </a>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col" style="display: flex;justify-content: center;">
            <a href="" href="/agent_betlist/">
            <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/find.png" width=50px/>
                <br/>
                
                  <span class='en'>Bet List</span>
                  <span class='cn'>投注清单</span>
                  <span class='tl'>Lista jogu</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/agent_report/" class="tab-link">
            <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/report.png" width=50px/>
                <br/>
                
                  <span class='en'>Report</span>
                  <span class='cn'>报告</span>
                  <span class='tl'>Relatoriu</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
          </div>
          
        </div>        
      </div>

      <div class="block rowsg" style="margin-top: 0px;">
        <div class="row">
          <div class="col" style="display: flex;justify-content: center;">
            <a href="#"  @click=${() => checkngo('/kiosk_4d_SG/','no')}>
            <div style="background-color: var(--f7-theme-color); width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/sg.png" width=40%/>
                <br/>
                4D,3D,2D
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="#" @click=${() => checkngo('/kiosk_pick_sg/','no')}>
            <div style="background-color: green; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/sg.png" width=40%/>
                <br/>
                SEPER PICK
              </span> 
            </div>
            </a>
          </div>

          <div class="col" style="display: flex;justify-content: center;">

          </div>     
        </div>
        <br/>
        <hr style="border: 1px dashed var(--f7-theme-color);"/>
        <br/>
        <div class="row">
          <div class="col" style="display: flex;justify-content: center;">
            <a href="#" @click=${() => checkngo('/kiosk_4d_SG_S/','yes')}>
            <div style="background-color: var(--f7-theme-color); width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/sg.png" width=40%/>
                <br/>
                Special
              </span> 
            </div>
            </a>
          </div>     
          <div class="col" style="display: flex;justify-content: center;">
            <a href="#" @click=${() => checkngo('/kiosk_pick_SG_S/','yes')}>
            <div style="background-color: green; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/sg.png" width=40%/>
                <br/>
                S Special
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <!-- <div class="col" @click="${alertNotReady}" style="display: flex;justify-content: center;"> -->
              <a href="/kiosk_result_sg/">
              <div style="background-color: gray; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
                <span style="color: black; text-align: center;">
                  <img src="static/images/sg.png" width=50%/>
                  <br/>
                  
                    <span class='en'>Result</span>
                    <span class='cn'>成绩</span>
                    <span class='tl'>Rejultadu</span>
                  
                </span> 
              </div>
              </a>
          </div>     
          
        </div>   
        <br/>
        <div class="row">
          <div class="col" style="display: flex;justify-content: center;">
            <a href="" href="/agent_betlist/" class="rowext2">
              <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
                <span style="color: white; text-align: center;">
                  <img src="static/images/find.png" width=50px/>
                  <br/>
                  
                    <span class='en'>Bet List</span>
                    <span class='cn'>投注清单</span>
                    <span class='tl'>Lista jogu</span>
                  
                </span> 
              </div>
              </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/agent_report/" class="tab-link">
            <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/report.png" width=50px/>
                <br/>
                
                  <span class='en'>Report</span>
                  <span class='cn'>报告</span>
                  <span class='tl'>Relatoriu</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <!-- <div class="col" @click="${alertNotReady}" style="display: flex;justify-content: center;"> -->
              <a href="/agent_jackpot/">
              <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
                <span style="color: white; text-align: center;">
                  <img src="static/images/jackpot1.png" width=50px/>
                  <br/>
                  Jackpot
                </span> 
              </div>
              </a>
            </div>
        </div>
        <br/>
        <div class="row">
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/agent_winning/" class="tab-link">
            <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/trophy.png" width=50px/>
                <br/>
                
                  <span class='en'>Winning</span>
                  <span class='cn'>中奖</span>
                  <span class='tl'>Manan nain</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">

          </div>
          <div class="col" style="display: flex;justify-content: center;">

          </div>
        </div>
      </div>
      <div class="block rowst" style="margin-top: 0px;">
        <div class="row">        
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/kiosk_4d_ST/">
            <div style="background-color: #2238BE; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/slotto.png" width=70%/>
                <br/>                
                6D/4,6D/3 <br/>
                3D Box, 2D
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/kiosk_6d_ST/">
            <div style="background-color: #2238BE; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/slotto.png" width=70%/>
                <br/>
                6D,6D/5
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/kiosk_pick_st/">
            <div style="background-color: green; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/slotto.png" width=70%/>
                <br/>
                SEPER PICK
              </span> 
            </div>
            </a>
          </div>
          
        </div>
        <br/>
        <div class="row">
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/kiosk_result_st/">
            <div style="background-color: gray; width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: black; text-align: center;">
                <img src="static/images/slotto.png" width=70%/>
                <br/>
                
                  <span class='en'>Result</span>
                  <span class='cn'>成绩</span>
                  <span class='tl'>Rejultadu</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/agent_winning/" class="tab-link">
            <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/trophy.png" width=50px/>
                <br/>
                
                  <span class='en'>Winning</span>
                  <span class='cn'>中奖</span>
                  <span class='tl'>Manan nain</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
          <!-- <div class="col" @click="${alertNotReady}" style="display: flex;justify-content: center;"> -->
            <a href="/agent_jackpot/">
            <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/jackpot1.png" width=50px/>
                <br/>
                Jackpot
              </span> 
            </div>
            </a>
          </div>
          
        </div>  
        <br/>
        <div class="row">
          <div class="col" style="display: flex;justify-content: center;">
            <a href="" href="/agent_betlist/" class="rowext2">
              <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
                <span style="color: white; text-align: center;">
                  <img src="static/images/find.png" width=50px/>
                  <br/>
                  
                    <span class='en'>Bet List</span>
                    <span class='cn'>投注清单</span>
                    <span class='tl'>Lista jogu</span>
                  
                </span> 
              </div>
              </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            <a href="/agent_report/" class="tab-link">
            <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/report.png" width=50px/>
                <br/>
                
                  <span class='en'>Report</span>
                  <span class='cn'>报告</span>
                  <span class='tl'>Relatoriu</span>
                
              </span> 
            </div>
            </a>
          </div>
          <div class="col" style="display: flex;justify-content: center;">
            
          </div>

        </div> 
      </div>  

    <hr style="border-color: #691313;"/>  
    <br/>
    <div class="block" style="margin-top: 0px;">
      <div class="row">

        <div class="col" style="display: flex;justify-content: center;">
          <a href="#" @click=${() => checkwallet('/gen_buypaper/')}>
          <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
            <span style="color: white; text-align: center;">
              <img src="static/images/buypaper.png" width=50px/>
              <br/>
              <span class='en'>Buy Ticket</span>
              <span class='cn'>买票</span>
              <span class='tl'>Sosa Ticket</span>
            </span> 
          </div>
          </a>
        </div>
        <div class="col" style="display: flex;justify-content: center;">
          <a href="/gen_longlong/">
          <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
            <span style="color: white; text-align: center;">
              <img src="static/images/aulonglong.png" width=43px/>
              <br/>
              Long Long 
            </span> 
          </div>
          </a>
        </div>
        <div class="col col-topup" style="display: flex;justify-content: center;">
          <a href="#" @click=${() => checkwallet('/gen_buytopup/')}>
          <div style="width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
            <span style="color: white; text-align: center;">
              <img src="static/images/topup.png" width=50px/>
              <br/>
              <span class='en'>Topup</span>
              <span class='cn'>充值</span>
              <span class='tl'>Topup</span>
            </span> 
          </div>
          </a>
        </div>
      </div>
    </div>
    <div class="block" style="margin-top: 0px;">
      <div class="row">
        <div class="col col-outstanding" style="display: flex;justify-content: center;">
          <a href="#" @click=${() => checkwallet('/gen_payoutstanding/')}>
          <div style="width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
            <span style="color: white; text-align: center;">

                <img src="static/images/bill.png" width=50px/>


              
              <br/>
              <span class='en'>Pay My Bill</span>
              <span class='cn'>支付我的账单</span>
              <span class='tl'>Selu ha'u-nia Bill</span>
            </span> 
          </div>
          </a>
          <a href="/gen_payoutstanding/">
            <span class="badge color-red badge-outstanding" style="position: relative; margin-left:-50px"></span>
          </a>
        </div>

        <div class="col col-outstanding" style="display: flex;justify-content: center;">
          <a href="/agent_wallet/">
          <div style="width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
            <span style="color: white; text-align: center;">
              <img src="static/images/purse.png" width=50px/>
              <br/>
              <span class='en'>e-Wallet</span>
              <span class='cn'>支付我的账单</span>
              <span class='tl'>Selu ha'u-nia Bill</span>
            </span> 
          </div>
          </a>
          <a href="/agent_wallet/">
            <span class="badge color-red badge-wallet" style="position: relative; margin-left:-50px"></span>
          </a>
        </div>

        <div class="col" style="display: flex;justify-content: center;">
          <!-- <a href="/gen_history/">
            <div style="width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
              <span style="color: white; text-align: center;">
                <img src="static/images/receipt.png" width=100%/>
                <br/>
                <span class='en'>History</span>
                <span class='cn'>历史</span>
                <span class='tl'>istória</span>
              </span> 
            </div>
            </a> -->
        </div>

 
      </div>
    </div>

    </div>
  </div>
`
    }
    ;
}

framework7Component.id = 'acd8867e3b';
export default framework7Component;